import React from 'react';
import * as cls from './how-it-works.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    title: 'Clamp-on sensor',
    text: 'attaches around the mains feed in the consumer unit.',
  },
  {
    title: 'Gateway connection',
    text: 'via Wi-Fi or GSM sends encrypted signals to Voltaware’s platform.',
  },
  {
    title: 'AI disaggregation',
    text: 'converts the signal into appliance-level events.',
  },
  {
    title: 'Insights delivered',
    text: 'in the Voltaware app, partner dashboards, or via APIs.',
  },
];

export const HowItWorks = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        How the Hardware Works
        <br />
        (at a glance)
      </Typography>

      <div className={cls.wrapper}>
        <div className={cls.textWrapper}>
          {items.map((item, index) => (
            <div key={index} className={cls.item}>
              <div className={cls.itemNumber}>
                <span>0{index + 1}</span>
              </div>
              <div>
                <Typography tag="h3">{item.title}</Typography>
                <Typography>{item.text}</Typography>
              </div>
            </div>
          ))}
        </div>
        <div className={cls.imgWrapper}>
          <img
            alt="Sensor and gateway, encrypted upload, AI disaggregation, app and dashboard insights."
            src={`${IMG_PATH}/our-technology/hardware/how-it-works.png`}
          />
        </div>
      </div>
      <div className={cls.info}>
        <img
          alt="Information"
          src={`${IMG_PATH}/our-technology/hardware/info-ico.svg`}
        />
        <Typography>
          Installation should follow local regulations and be performed by a
          professional electrician. No rewiring is required.
        </Typography>
      </div>
    </Section>
  );
};
